/**
 * Refresca la sesión y actualiza el espejo de cookies que la app manda como
 * Bearer. Devuelve si el refresco realmente funcionó — no basta con mirar la
 * cookie, porque la vieja sigue ahí y sigue siendo truthy cuando esto falla.
 */
export default async function useRefreshToken(): Promise<boolean> {
  const log = useLogger('composable:useRefreshToken')
  const supabase = useSupabaseClient()

  const sbAccessToken = useCookie('sb-access-token')
  const sbRefreshToken = useCookie('sb-refresh-token')

  try {
    const { data, error } = await supabase.auth.refreshSession()

    if (error) {
      log.error('Error refreshing session:', error)
      return false
    }

    if (!data.session) {
      log.warn('refreshSession devolvió sin sesión')
      return false
    }

    sbAccessToken.value = data.session.access_token
    sbRefreshToken.value = data.session.refresh_token
    return true
  }
  catch (error) {
    log.error('Error refreshing session:', error)
    return false
  }
}
